export default {

  fetchProducts(vm) {
    axios.get(`/api/product/search-autocomplete/${vm.strSearch}`)
      .then((response) => {
          vm.products = response.data.products;
      });
  },

};
